import type {
  HardwareAssetKind,
  HardwareAssetStatus,
  HardwareComponentFamily,
  ObjectiveDataModality,
} from '@ddp/shared';

import type { MessageKey } from '../../i18n/index.js';

/**
 * Correspondances code → clé i18n pour la flotte (ADR-0029). Centralisées ici : la grille de cartes
 * et la fiche parlent le même langage, et l'ajout d'un type de matériel ne touche pas la mise en page.
 */

export const KIND_LABEL: Record<HardwareAssetKind, MessageKey> = {
  DRONE: 'fleet.kind.DRONE',
  UGV: 'fleet.kind.UGV',
  COMPUTE: 'fleet.kind.COMPUTE',
  SENSOR: 'fleet.kind.SENSOR',
  OTHER: 'fleet.kind.OTHER',
};

/** Intention visuelle d'un statut de parc : couleur (ok/warn/info/neutre) + libellé i18n. */
export const STATUS_META: Record<HardwareAssetStatus, { cls: string; key: MessageKey }> = {
  ACTIVE: { cls: 'ok', key: 'fleet.status.ACTIVE' },
  BENCH: { cls: 'info', key: 'fleet.status.BENCH' },
  MAINTENANCE: { cls: 'warn', key: 'fleet.status.MAINTENANCE' },
  STOCK: { cls: 'neutral', key: 'fleet.status.STOCK' },
};

export const FAMILY_LABEL: Record<HardwareComponentFamily, MessageKey> = {
  COMPUTE: 'fleet.family.COMPUTE',
  SENSOR: 'fleet.family.SENSOR',
  AIRFRAME: 'fleet.family.AIRFRAME',
};

/** Modalité capteur : réutilise le référentiel de l'objectif (contrat unique). */
export const MODALITY_LABEL: Record<ObjectiveDataModality, MessageKey> = {
  OPTICAL: 'objective.modality.OPTICAL',
  INFRARED: 'objective.modality.INFRARED',
  ACOUSTIC: 'objective.modality.ACOUSTIC',
  RADAR: 'objective.modality.RADAR',
  TELEMETRY: 'objective.modality.TELEMETRY',
};
